export default "__VITE_ASSET__y88uOXvs__"